import { generateAPI } from "../api.generator";

export interface RecordViewResponse {
  success: boolean;
  message: string;
}

export const recordNotificationView = generateAPI<
  Record<string, unknown>,
  RecordViewResponse
>("post", "notifications/record-view");
